<template>
  <v-data-table
    item-key="id"
    :options.sync="tableOptions"
    :items-per-page="10"
    :server-items-length="count"
    :headers="headers"
    :footer-props="footerTable"
    :items="items"
    sort-by="name"
    v-bind="this.$attrs"
    loading-text="Đang Tải"
    :loading="loading"
    no-data-text="Không có lớp"
    disable-sort
  >
    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt| ddmmyyyy }}
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div v-on="on" style="text-decoration: none; white-space: nowrap">
            <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/boarding-class/' + item.id">{{
              item.name
            }}</router-link>
          </div>
        </template>
        <span>Xem lớp bán trú</span>
      </v-tooltip>
    </template>
    <template v-slot:[`item.phone`]="{ item }">
      {{ item.phone }}
    </template>
    <template v-slot:[`item.teacher`]="{ item }">
      {{ item.teacher ? item.teacher.name : '' }}
    </template>
    <template v-slot:[`item.maxStudent`]="{ item }">
      {{ item.data && item.data.maxStudent }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <v-chip
        small
        style="margin: 0"
        class="white--text"
        v-if="item.status"
        :color="item.status | boardingClassStatusColor"
        label
      >
        {{ item.status | boardingClassStatus }}
      </v-chip>
    </template>

      <!-- Thao tác -->
      <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon color="primary">
            <router-link v-on="on" style="text-decoration: none; white-space: nowrap" :to="'/boarding-class/' + item.id">
              <v-icon>mdi-eye-outline</v-icon></router-link>
          </v-btn>
      </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'

const originHeaders = [
  { text: 'Tên lớp bán trú', value: 'name' },
  { text: 'Sĩ số học sinh', value: 'studentCount' },
  { text: 'Số giáo viên phụ trách', value: 'teacherCount' },
  { text: 'Ngày tạo', value: 'createdAt' },
  { text: 'Trạng thái', value: 'status' },
  { text: 'Thao tác', value: 'actions' },
]

export default {
  props: {},
  data() {
    return {
      headers: originHeaders,
      status: null,
      tableOptions: {},
    }
  },
  methods: {
    ...mapActions('boardingClass', ['requestPageSettings', 'search']),
    cancel() {
      this.$emit('cancel')
      this.dialog = false
    },
    async refresh(query) {
      await this.search(query || {})
    },
  },
  computed: {
    ...mapState('boardingClass', ['items', 'count', 'pageText', 'loading']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Lớp mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
